import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { invokeArchiveUser } from "src/app/store/user/user.actions";

@Component({
  selector: "app-confirmation-modal",
  templateUrl: "./confirmation-modal.component.html",
})
export class ConfirmationModalComponent implements OnInit {
  @Input() actionLabel: string;
  @Input() targetType: string;
  @Input() targetName: string;
  @Input() title : string
  @Output() confirmAction: EventEmitter<boolean> = new EventEmitter();
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter();

  loading : boolean = false
  constructor() {}

  ngOnInit(): void {}

  onClickCloseModal(){
    this.closeModal.emit(true)
  }

  onClickConfirmAction(){
    this.loading = true
    this.confirmAction.emit(true)
  }
}
